module.exports = __webpack_public_path__ + "img/pinguinitos-bg.9d603b88.jpg";